import styled from 'styled-components';
import HomePage from './pages/homepage';
import Legends5908 from './pages/Legends5908';
import LoginPage from './pages/login'
import TableCard from './components/tableCard';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import React from 'react';
import { useState } from "react";
import {Switch, Route} from 'react-router-dom';
import TimeClock from './pages/timeclock';
import { Context } from './components/Context';

// Signed-in user context
// const UserContext = React.createContext({
//   name: 'Guest',
//   api_key:''
// });


function App() {
  const [context, setContext] = useState(
    {
      name: 'Guest',
      api_key:'',
      isLoggedIn:false
    }
  );

  return (
    <HelmetProvider>
    <AppTag>
        <Helmet>
          <meta 
            charSet="utf-8" 
            />
            <meta 
            name="keywords"  
            content = "bigdog properties, flippers friend, flipping tools, flipping app"
            />
          <meta 
            name="description"  
            content = "Home of Bigdog Properties and Flippers Friend"
            />

          <title>Big Dog Properties</title>
      </Helmet>
      {/* <Navbar/> */}
      <MainContent>
        <Context.Provider value={[context, setContext]}>
          <Switch>
            <Route path="/" exact>
              <HomePage/>
            </Route>
            {/* <Route path='/reports' component={Reports} exact/> */}
            <Route path='/table' component={TableCard} exact/>
            <Route path='/5908legends' component={Legends5908} exact/>
            <Route path='/login' component={LoginPage} exact/>
            <Route path='/timeclock' component={TimeClock} exact/>
          </Switch>
        </Context.Provider>
      </MainContent>
    </AppTag>
    </HelmetProvider>
  );
}

const AppTag = styled.div`
  text-align: center;
  min-height:100vh;
  width:100%;
  /* background-color:var(--primary-color); */
`;

const MainContent = styled.main`
  position:relative;
  /* margin-left:16.3rem; */
  min-height:100vh;

  /* .lines{
    position:absolute;
    min-height:100vh;
    width:100%;
    display:flex;
    justify-content:space-evenly;

    .line-1, .line-2, .line-3, .line-4{
      width:1px;
      min-height:100vh;
      background-color:var(--border-color);
    }
  } */

`;

export default App;
